<div class="title">
  <button (click)="handleClick()" *ngIf="backButton">
    <img class="arrow" src="assets/icons/arrow-back.svg" alt="Arrow" />
  </button>
  <h1>{{ title }}</h1>
  <div>
    <div
      class="subtitle"
      (click)="bottomSheetText && openBottomSheet()"
      [class.pointer]="bottomSheetText"
    >
      <h3 *ngIf="subtitle" [class.extra-info]="bottomSheetText" [innerHTML]="subtitle"></h3>
      <img
        class="info-icon"
        *ngIf="bottomSheetText"
        src="assets/icons/input-hint-warning.svg"
        alt="info"
      />
    </div>

    <p *ngIf="information">{{ information }}</p>
  </div>
</div>
